import React from 'react';
import cx from 'classnames';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../../common/GradientWrapper/index.js';
import { Icon } from '../../../../common/Icon/index.js';
import '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import '../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const Button = ({
  className,
  style,
  icon,
  customIcon,
  v2,
  onClick
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    className: cx(styles.box, className, {
      [styles.v2]: v2
    }),
    style,
    onClick,
    "aria-label": "social"
  },
  /* @__PURE__ */ React.createElement("span", { className: styles.icon }, /* @__PURE__ */ React.createElement(Icon, { customIcon, iconName: icon }))
);

export { Button };
//# sourceMappingURL=index.js.map
